import React from 'react';
import Select from 'react-select';

const TypeaheadAdd = (props) => {
  return (
    <Select
      options={props.options}
      onChange={(selectedOption) => props.onChange(selectedOption)}
      // onChange={props.onChange} 
      value={props.value}
      className="col-sm-11"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          zIndex: 1000, 
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'rgba(83, 70, 134, 0.474)',
          primary: '#534686',
          primary50: 'rgba(83, 70, 134, 0.3)'
        },
      })}
    />
  );
}

export default TypeaheadAdd;